import { Ref } from 'react';

import { FormattedMessage } from 'react-intl';

import { CommonDefaultButtonProps } from '@atlaskit/button/dist/types/new-button/variants/default/types';
import Button from '@atlaskit/button/new';
import { CustomTriggerProps } from '@atlaskit/dropdown-menu';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import OfficeBuildingIcon from '@atlaskit/icon/core/office-building';
import { Inline } from '@atlaskit/primitives';

import { CustomerDomainOrg } from '@/state/types';

import { messages } from '../messages';
import { OrgSelectorItemMessage } from '../org-selector-item-message';

export const OrgSelectorDropdownButton = ({
	triggerRef,
	selectedDomainOrg,
	isLoading,
	isDisabled,
	sendOrgSelectorDropdownClickUIEvent,
	spacing = 'compact',
	...providedProps
}: CustomTriggerProps & {
	selectedDomainOrg: CustomerDomainOrg | null;
	isLoading: boolean;
	isDisabled: boolean;
	sendOrgSelectorDropdownClickUIEvent: () => void;
	spacing?: CommonDefaultButtonProps['spacing'];
}) => {
	return (
		<Button
			ref={triggerRef as Ref<HTMLButtonElement>}
			{...providedProps}
			spacing={spacing}
			isDisabled={isDisabled}
			isLoading={isLoading}
			onClick={(e) => {
				sendOrgSelectorDropdownClickUIEvent();
				providedProps.onClick?.(e);
			}}
		>
			<Inline space="space.100" alignInline="center" alignBlock="center">
				<OfficeBuildingIcon label="" />
				{selectedDomainOrg ? (
					<OrgSelectorItemMessage org={selectedDomainOrg} />
				) : (
					<FormattedMessage {...messages.orgSelectorDropdownNoOrgSelected} />
				)}
				<ChevronDownIcon label="" size="small" />
			</Inline>
		</Button>
	);
};
